import { TextLink } from "@itandi/itandi-bb-ui/TextLink";
import type { DealWithPrices } from "~/models/Deal";
import { getSkFullPath, PATH } from "~/utils/SeisanKanriPath";
import Styles from "./RelatedDealRow.module.scss";

type Props = {
	deal: DealWithPrices;
	notTargetDeal: boolean;
};

export function RelatedDealRowSkLink({ deal, notTargetDeal }: Props) {
	return (
		<div className={Styles.SkLinkBlock}>
			<h4 className={Styles.ContextLabel}>精算管理登録</h4>
			{deal.skPartnerDeal?.linked ? (
				<TextLink
					color="link"
					href={getSkFullPath(PATH.partnerDeal(deal.skPartnerDeal.id))}
				>
					登録済
				</TextLink>
			) : (
				<div>
					{!notTargetDeal && (
						<TextLink
							color="link"
							href={`${getSkFullPath(PATH.partnerDealsNew)}?nskDealId=${deal.id}`}
						>
							登録
						</TextLink>
					)}
				</div>
			)}
		</div>
	);
}
